module.exports = __webpack_public_path__ + "v4assets/perf-monitor-services.2287be6d19b2b89dd71b14ff81f462b7.png";